export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11288.8b4ac8ed.jpg";